const _none = "none"
const config = { "none": _none,  }
export { config as default, _none }